import { Text } from "@ui-component-library";
import { TailwindWrapper } from "@utils/TailwindWrapper";

export const HeadingPosts = (props: { title?: string }) => {
  
    return (
        <TailwindWrapper>
            <div className="mx-auto mb-6 flex max-w-[720px] flex-col px-4 sm:px-6">
                <Text variant="text-5xl/leading-normal/extrabold">
                    {props.title || "Heading posts"}
                </Text>
            </div>
        </TailwindWrapper> 
    );
  };

HeadingPosts.fields = {
    title: {
        type: "text",
        label: "Title",
      },
}